module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAAAAABWESUoAAAAGElEQVQ4y2M0YMAPmBhGFYwqGFUwQhUAAE3/AHApoIQZAAAAAElFTkSuQmCC"